import type { UtmData } from '~/schemas/utm'
import { fetchApi } from './helpers'

/**
 * The touch pair travels with the signup (BOAT-1893).
 *
 * The newsletter is the one place a visitor hands us an address with no
 * intention of buying yet, so it is often the earliest — and sometimes the
 * only — moment we can see how they found us. Sending nothing here meant every
 * one of those 2,190 rows was unattributed.
 */
export const newsletterSubscribe = ({
  name,
  email,
  utm,
  first_touch_utm: firstTouchUtm,
}: {
  name: string
  email: string
  utm?: UtmData
  first_touch_utm?: UtmData
}) =>
  fetchApi(`/newsletter`, {
    method: 'POST',
    body: {
      name,
      email,
      ...(utm ? { utm } : {}),
      ...(firstTouchUtm ? { first_touch_utm: firstTouchUtm } : {}),
    },
  })
